import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSentimentVeryNegative = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21.4208 12.2441C21.4208 17.2147 17.3913 21.2441 12.4208 21.2441C7.45021 21.2441 3.42078 17.2147 3.42078 12.2441C3.42078 7.27358 7.45021 3.24414 12.4208 3.24414C17.3913 3.24414 21.4208 7.27358 21.4208 12.2441Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8937 16.1826C15.664 15.3079 14.0541 14.8686 12.4425 14.8647C10.8164 14.8607 9.18856 15.3 7.94788 16.1826",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8937 10.1443L14.6802 11.9036L16.3261 12.2441",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.94788 10.1443L10.1613 11.9036L8.51547 12.2441",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSentimentVeryNegative;
